<template>
    <a-card :bordered="false" class="widget-1" :headStyle="{ height:'48px'}" :bodyStyle="{ paddingLeft: '8px',  paddingRight: '8px',  paddingTop: '10px', paddingBottom: '5px'}">
        <template #title>
            Cantidad de Pantallas
        </template>
        <a-statistic :value="my_service.screens" style="margin-right: 50px" :value-style="{ color: '#cf1322', textAlign: 'center'  }">
            <template #prefix>
                <span><PlaySquareOutlined /></span>
            </template>
        </a-statistic>
    </a-card>    
</template>
<script>
import { formatDate }  from '@/plugins/odoo_table'
import { PlaySquareOutlined } from '@ant-design/icons-vue';
export default {
    components: {
        PlaySquareOutlined
    },
    props: {
        my_service: {
            type: Object,
            required: true
        }
    },
    methods: {
        formatDate
    }

}
</script>